import { AuthGuard } from '@/components';

import { PersonalDetailsPage } from './page';

export const PersonalDetails = () => {
  return <AuthGuard>
    <PersonalDetailsPage />
  </AuthGuard>
};
